import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"label":"Type","items":_vm.placementTypesList,"item-text":"label","item-value":"id","outlined":"","clearable":"","dense":_vm.dense},model:{value:(_vm.placementTypeValue),callback:function ($$v) {_vm.placementTypeValue=$$v},expression:"placementTypeValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }